// vant 2.12.27 未自带 ko-KR 语言包，此包按 vant/lib/locale/lang/zh-CN.js 的完整 key 树补齐
export default {
  name: '이름',
  tel: '전화번호',
  save: '저장',
  confirm: '확인',
  cancel: '취소',
  delete: '삭제',
  complete: '완료',
  loading: '로딩 중...',
  telEmpty: '전화번호를 입력해 주세요',
  nameEmpty: '이름을 입력해 주세요',
  nameInvalid: '올바른 이름을 입력해 주세요',
  confirmDelete: '삭제하시겠습니까',
  telInvalid: '올바른 휴대폰 번호를 입력해 주세요',
  vanCalendar: {
    end: '종료',
    start: '시작',
    title: '날짜 선택',
    confirm: '확인',
    startEnd: '시작/종료',
    weekdays: ['일', '월', '화', '수', '목', '금', '토'],
    monthTitle: function monthTitle(year, month) {
      return year + '년 ' + month + '월'
    },
    rangePrompt: function rangePrompt(maxRange) {
      return '최대 ' + maxRange + '일까지 선택할 수 있습니다'
    }
  },
  vanCascader: {
    select: '선택해 주세요'
  },
  vanContactCard: {
    addText: '연락처 추가'
  },
  vanContactList: {
    addText: '새 연락처'
  },
  vanPagination: {
    prev: '이전',
    next: '다음'
  },
  vanPullRefresh: {
    pulling: '아래로 당겨서 새로고침...',
    loosing: '놓으면 새로고침...'
  },
  vanSubmitBar: {
    label: '합계:'
  },
  vanCoupon: {
    unlimited: '사용 조건 없음',
    discount: function discount(_discount) {
      return (100 - _discount * 10) + '% 할인'
    },
    condition: function condition(_condition) {
      return _condition + '원 이상 사용 가능'
    }
  },
  vanCouponCell: {
    title: '쿠폰',
    tips: '사용 가능한 쿠폰 없음',
    count: function count(_count) {
      return _count + '장 사용 가능'
    }
  },
  vanCouponList: {
    empty: '쿠폰이 없습니다',
    exchange: '교환',
    close: '쿠폰 사용 안 함',
    enable: '사용 가능',
    disabled: '사용 불가',
    placeholder: '쿠폰 코드를 입력해 주세요'
  },
  vanAddressEdit: {
    area: '지역',
    postal: '우편번호',
    areaEmpty: '지역을 선택해 주세요',
    addressEmpty: '상세 주소를 입력해 주세요',
    postalEmpty: '우편번호 형식이 올바르지 않습니다',
    defaultAddress: '기본 주소로 설정',
    telPlaceholder: '수령인 전화번호',
    namePlaceholder: '수령인 이름',
    areaPlaceholder: '시 / 도 / 구 선택'
  },
  vanAddressEditDetail: {
    label: '상세 주소',
    placeholder: '도로명, 건물/동/호수 정보'
  },
  vanAddressList: {
    add: '새 주소 추가'
  }
}
